// extracted by mini-css-extract-plugin
export default {"root":"cCVcwZnNe8VGjlZvWRLB","img":"ea8RlX_xlWpoeDQlTEfn"};